import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SSO_URL = `${process.env.REACT_APP_API_URL || '/api'}/auth/sso`;

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const err = params.get('error');
    if (err) {
      const msgs = {
        no_email: 'Could not retrieve email from Microsoft account.',
        token_failed: 'Microsoft authentication failed. Please try again.',
        sso_failed: 'Sign in failed. Please try again.',
        missing_token: 'Authentication incomplete. Please try again.',
      };
      setError(msgs[err] || 'Sign in failed. Please try again.');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>🏢 Pillar Tour</h1>
          <p>Certus Healthcare Management</p>
        </div>

        {error && <div className="login-error">{error}</div>}

        <a href={SSO_URL} style={{ textDecoration: 'none' }}>
          <button type="button" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, padding: '11px 16px', borderRadius: 6, border: '1px solid #D1D5DB', background: 'white', cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#1F2937', marginBottom: 16 }}>
            <svg width="20" height="20" viewBox="0 0 21 21" fill="none">
              <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
              <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
              <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
              <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
            </svg>
            Sign in with Microsoft
          </button>
        </a>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
          <div style={{ flex: 1, height: 1, background: '#E5E7EB' }} />
          <span style={{ fontSize: 12, color: '#9CA3AF' }}>or sign in with password</span>
          <div style={{ flex: 1, height: 1, background: '#E5E7EB' }} />
        </div>

        {showPassword ? (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input type="email" className="form-control" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@certushc.com" required autoFocus />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input type="password" className="form-control" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: 8 }} disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        ) : (
          <button type="button" style={{ width: '100%', padding: '10px', border: '1px solid #E5E7EB', borderRadius: 6, background: '#F9FAFB', color: '#6B7280', fontSize: 13, cursor: 'pointer' }} onClick={() => setShowPassword(true)}>
            Admin / Password Login
          </button>
        )}

        <p style={{ textAlign: 'center', color: 'var(--gray-500)', fontSize: 12, marginTop: 20 }}>Contact your administrator for access</p>
      </div>
    </div>
  );
}
